<template>
  <div class="create-link-wizard">
    <div @click="close()" class="close">
      <CloseIcon />
      <span class="close-text">ESC</span>
    </div>
    <div class="wizard-sidebar ">
      <div class="progress">
        <template v-if="link.type === 'pre-release'">
          <div class="source-link" :class="{ active: currentStep === 1 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <LinkIcon />
                </div>
              </div>
              <span>Release date and source</span>
            </div>
            <div class="separator"></div>
          </div>
          <div class="landing-page" :class="{ active: currentStep === 2 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <ViewIcon />
                </div>
              </div>
              <span>Link Customization</span>
            </div>
            <div class="separator"></div>
          </div>
          <div class="pre-release" :class="{ active: currentStep === 3 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Pre-release Services</span>
            </div>
            <div class="separator"></div>
          </div>
          <div class="destinations" :class="{ active: currentStep === 4 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Post-release Destinations</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="landing-page" @click="goToStep(1)" :class="{ active: currentStep === 1 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <ViewIcon />
                </div>
              </div>
              <span>Set Up Landing Page</span>
            </div>
            <div class="separator"></div>
          </div>
          <div class="destinations" @click="goToStep(2)" :class="{ active: currentStep === 2 }">
            <div class="icon-and-text">
              <div class="icon-container">
                <div class="icon-wrapper">
                  <DashboardIcon />
                </div>
              </div>
              <span>Set Up Destinations</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="steps-container">
      <template v-if="link.type === 'pre-release'">
        <LinkWizardPreReleaseSource v-if="currentStep === 1" action="edit" :link="link" ref="stepOne" @close="close()"
          @setStep="setStep" />
        <LinkWizardCustomize v-if="currentStep === 2" action="edit" :link="link" :destinations="destinations"
          ref="stepOne" @back="back()" @close="close()" @setStep="setStep" />
        <LinkWizardPreReleaseServices v-if="currentStep === 3" action="edit" :link="link" :destinations="destinations"
          ref="stepOne" @back="back()" @close="close()" @setStep="setStep" />
        <LinkWizardPreReleaseFinal v-if="currentStep === 4" action="edit" :link="link" :destinations="destinations"
          ref="stepOne" @back="back()" @close="close()" @setStep="setStep" @finish="finish()" />
      </template>
      <template v-else>
        <LinkWizardCustomize v-if="currentStep === 1" action="edit" :link="link" :destinations="destinations"
          ref="stepOne" @close="close()" @setStep="setStep" />
        <LinkWizardDestinations v-if="currentStep === 2" action="edit" :link="link" :destinations="destinations"
          ref="stepTwo" @back="back()" @close="close()" @setStep="setStep" @finish="finish()" />
      </template>
    </div>
  </div>
</template>
<script>
import LinkIcon from "../../../public/img/icons/link-gradient.svg";
import ViewIcon from "../../../public/img/icons/view-gradient.svg";
import DashboardIcon from "../../../public/img/icons/dashboard-gradient.svg";
import CloseIcon from "../../../public/img/icons/close.svg";
import LinkWizardPreReleaseSource from "@/components/Custom/LinkWizardPreReleaseSource";
import LinkWizardCustomize from "@/components/Custom/LinkWizardCustomize";
import LinkWizardPreReleaseServices from "@/components/Custom/LinkWizardPreReleaseServices";
import LinkWizardPreReleaseFinal from "@/components/Custom/LinkWizardPreReleaseFinal";
import LinkWizardDestinations from "@/components/Custom/LinkWizardDestinations";

export default {
  name: "EditLinkWizard",
  components: {
    LinkIcon,
    ViewIcon,
    DashboardIcon,
    CloseIcon,
    LinkWizardPreReleaseSource,
    LinkWizardCustomize,
    LinkWizardPreReleaseServices,
    LinkWizardPreReleaseFinal,
    LinkWizardDestinations,
  },
  props: ["link", "destinations"],
  data() {
    return {
      currentStep: 1,
    };
  },
  created() {
    // if (this.link.id !== this.$store.state.editLinkWizardData.id)
    this.$store.commit("resetEditLinkWizardData");
  },
  computed: {},
  methods: {
    goToStep(step) {
      if (step === 2) {
        this.$refs.stepOne.next();
      } else if (step === 1) {
        this.$refs.stepTwo.back();
      }
    },
    setStep(step) {
      this.currentStep = step;
    },
    finish() {
      this.$emit("finish");
    },
    back() {
      if (this.currentStep === 1) {
        this.close();
      } else {
        this.currentStep--;
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>


.create-link-wizard::-webkit-scrollbar {
  display: none;
}

.create-link-wizard {
  overflow-y: auto;
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* BG/type1 */
  background: $bg-type-1;

  

  .wizard-sidebar {
    display: flex;
    margin-top: 66px;
    justify-content: center;

    .progress {
      display: flex;

      .link-type,
      .source-link,
      .landing-page,
      .pre-release,
      .destinations {
        display: flex;

        &:not(.active) {
          .icon-and-text {
            .icon-container {
              svg {
                path {
                  fill: $text-type-2;
                }
              }
            }
          }
        }

        &.active,
        &.landing-page:hover,
        &.pre-release:hover,
        &.destinations:hover {
          .icon-and-text {
            cursor: pointer;

            .icon-container {
              background: linear-gradient(46.19deg,
                  #9c27b0 5.66%,
                  #9733ee 94.35%);
            }

            span {
              color: white;
              cursor: pointer;
            }
          }

          .separator {
            background: linear-gradient(46.19deg,
                #9c27b0 5.66%,
                #9733ee 94.35%);
          }
        }

        .icon-and-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 100px;

          .icon-container {
            width: 46px;
            height: 46px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 1px;
            background: $text-type-2;
            border-radius: 50px;

            .icon-wrapper {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              background: $bg-type-1;
              border-radius: 50px;

              svg {
                width: 24px;
              }
            }
          }

          span {
            margin-top: 6px;
            /* 14/SemiBold */
            font-weight: 600;
            font-size: 14px;
            line-height: 22px;
            /* Text/type2 */
            color: $text-type-2;
          }
        }

        .separator {
          margin-top: 23px;
          height: 1px;
          width: 36px;
          background: $text-type-2;
        }
      }
    }
  }

  .steps-container {
    flex: 1;
    display: flex;
    justify-content: center;
    //overflow-y: scroll;
    overflow-y: auto;
    //padding: 60px 0;
  }

  .close {
    z-index: 2;
    cursor: pointer;
    position: fixed;
    top: 26px;
    right: 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:hover {
      svg {
        path {
          fill: white;
        }
      }

      .close-text {
        color: white;
      }
    }

    svg {
      width: 18px;
      margin: 3px 0;

      path {
        fill: #8786ab;
      }
    }

    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }


  @media screen and (max-width: 870px) {
  .progress {
    padding: 0 10px;
    margin-top: 45px;
  }
}



@media screen and (max-width: 760px) {
  .close {
    z-index: 100;
  }

  .icon-and-text {
    text-align: center
  }
}

@media screen and (max-width: 560px) {

 
  .close {
    z-index: 100;
  }

  .icon-and-text {
    text-align: center;
    width: 60px;
  }

  .icon-and-text span {
    display: none;
  }

  .separator {
    width: 15px !important;
  }

  .icon-container {
    height: 35px !important;
    width: 35px !important;
  }

  .icon-and-text {
    min-width: 0 !important;
  }

}
}
</style>
